/** @format */

import { CustomHttpHeaders, MediaType } from '@shared/data-access/enums';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
	IAvsRequest,
	IAvsRequestV2,
	IAvsResponse,
	IAvsResponseV2
} from '@cart-checkout/checkout/data-access/interfaces';
import { map, retryWhen } from 'rxjs/operators';

import { DCSG_CONSTANTS } from '@shared/data-access/constants';
import { Environment } from '@shared/data-access/interfaces';
import { Injectable } from '@angular/core';
import { Logger, httpScalingRetryStrategy } from '@shared/data-access/services';

import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class AvsDao {
	constructor(
		private http: HttpClient,
		private environment: Environment,
		private logger: Logger
	) {}

	private DEFAULT_HEADERS = {
		Accept: MediaType.APPLICATION_JSON,
		'Content-Type': MediaType.APPLICATION_JSON,
		'Access-Control-Allow-Origin': '*',
		'Cache-Control': 'no-cache,no-store,must-revalidate,max-age=0',
		Pragma: 'no-cache',
		Expires: 'Sat, 01 Jan 2000 00:00:00 GMT'
	};

	// HTTP Headers
	private HTTP_HEADERS = new HttpHeaders(this.DEFAULT_HEADERS);

	/**
	 * @returns {Observable<IAvsResponse>}
	 *
	 * @description
	 * Function that calls the AvsDao to call Shipping AVS API.  This coarse-grain API can accept an empty Object {}, or
	 * an Object with User address {'addressLines': 'STRING[]', 'city': 'STRING', 'state': 'STRING', 'zipcode': 'STRING', 'country': 'STRING' }.
	 *
	 * @param avsRequest
	 */
	public verifyAddress$(avsRequest: IAvsRequest = null): Observable<IAvsResponse> {
		// HTTP Options
		const httpOptions = {
			headers: this.HTTP_HEADERS
		};

		httpOptions.headers = httpOptions.headers.set(
			CustomHttpHeaders.X_TIMEOUT,
			`${DCSG_CONSTANTS.timeouts.medium}`
		);

		// Make the HTTP Request
		return this.http
			.post<IAvsResponse>(
				`${this.environment.api.avsApi.origin}${this.environment.api.avsApi.baseUrl}`,
				avsRequest,
				httpOptions
			)
			.pipe(
				map((avsResponse: IAvsResponse) => {
					// Return the raw data
					return avsResponse;
				}),
				retryWhen(
					httpScalingRetryStrategy({
						maxRetryAttempts: 3,
						scalingDuration: 1000,
						excludedStatusCodes: undefined,
						logger: this.logger
					})
				)
			);
	}

	/**
	 * @returns {Observable<IAvsResponseV2>}
	 *
	 * @description
	 * Function that calls the Shipping AVS V2 verification endpoint.
	 *
	 * @param avsRequest
	 */
	public verifyAddressV2$(avsRequest: IAvsRequestV2 = null): Observable<IAvsResponseV2> {
		const V2_HEADERS = {
			...this.DEFAULT_HEADERS,
			ProductId: 'CHECKOUT-UI',
			ApplicationId: 'cart'
		};

		const HTTP_V2_HEADERS = new HttpHeaders(V2_HEADERS);

		// HTTP Options
		const httpOptions = {
			headers: HTTP_V2_HEADERS
		};

		httpOptions.headers = httpOptions.headers.set(
			CustomHttpHeaders.X_TIMEOUT,
			`${DCSG_CONSTANTS.timeouts.medium}`
		);

		// Make the HTTP Request
		return this.http
			.post<IAvsResponseV2>(
				`${this.environment.api.avsApiV2.origin}${this.environment.api.avsApiV2.baseUrl}`,
				avsRequest,
				httpOptions
			)
			.pipe(
				map((avsResponse: IAvsResponseV2) => {
					// Return the raw data
					return avsResponse;
				}),
				retryWhen(
					httpScalingRetryStrategy({
						maxRetryAttempts: 3,
						scalingDuration: 1000,
						excludedStatusCodes: undefined,
						logger: this.logger
					})
				)
			);
	}
}
